exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n._v-container > ._v-content > .loading-layer > .no-data-text,\r\n._v-container > ._v-content > .loading-layer > .spinner-holder {\r\n  display: none !important;\n}\r\n", ""]);

// exports
